import Actor from "./Actor";
import common from "../common";

export default class Dorothy extends Actor {
    constructor() {
        super();
        this.view = new PIXI.spine.Spine(P3.assets.spineData("dorothy"));
        this.view.position.set(0);
        this.view.scale.set(0.5);
        this.view.skeleton.setToSetupPose();
        this.view.skeleton.setSkin(null);
        this.view.skeleton.setSkinByName("dorothy");
        this.view.autoUpdate = false;
        this.view.update(0);
        this.addChild(this.view);

        this.view.state.addListener({
            complete: this._onAnimationComplete.bind(this),
            event: this._onAnimationEvent.bind(this)
        });
        this.view.stateData.defaultMix = 0.2;
        this._jumpOutFinished = new P3.utils.MiniSignal();

        //Animations
            //dough_mix2
            //dough_mix-old
            //dough_thinking
            //happy_001
            //happy_002
            //happy_003
            //jump_in
            //jump_out
            //idle
            //idle_splash
            //photo_enter_scene
            //photo_idle
            //photo_pose_001
            //photo_pose_002
            //photo_pose_003
    }

    update(dt) {
        this.view.update(dt);
    }

    playSplashIdleAnimation() {
        this.view.state.setAnimation(0, "idle_splash", true);
        this.view.state.timeScale = 1;
    }

    //===========================
    //Entrance/Exit
    //===========================

    playJumpInAnimation(){
        this.view.state.setAnimation(0, "jump_in", false);
        this.playIdleAnimation();
    }

    playJumpOutAnimation(){
        this.view.state.setAnimation(0, "jump_out", false);
    }

    //============================
    //BAKING
    //============================

    playIdleAnimation(){
        this.view.state.addAnimation(0, "idle", false, 0);
    }

    playDoughMixingAnimaton(){
        this.view.state.setAnimation(0, "dough_mix2", false);
        this.view.scale.x = -0.5;
        this.playIdleAnimation();
    }

    playDoughThinkingAnimaton(){
        this.view.state.setAnimation(0, "dough_thinking", false);
        this.playIdleAnimation();
    }

    playContinousMixing(){
        this.view.state.setAnimation(0, "dough_mix2", true);
    }

    playHappAnimation(number){
        this.view.state.setAnimation(0, "happy_00" + number, false);
        this.playIdleAnimation();
    }

    //=============================
    //PHOTO SCENE
    //=============================

    playPhotoIdleAnimation(){
        this.view.state.addAnimation(0, "photo_idle", false, 0);
    }

    playPhotoEnterAnimation(){
        this.view.state.setAnimation(0, "photo_enter_scene", false);
        this.playPhotoIdleAnimation();
    }

    playPhotoPoseAnimation(number){
        this.view.state.setAnimation(0, "photo_pose_00" + number, false);
        this.playPhotoIdleAnimation();
    }

    playRandomPhotoPose(){
        this.view.state.setAnimation(0, "photo_pose_00" + common.getRandomInt(1,3), false, 0);
        this.playPhotoIdleAnimation();
    }

    //=============================
    //CALLBACKS
    //=============================

    _onAnimationComplete(entry) {
        const name = entry.animation.name;
        if (["idle"].indexOf(name) !== -1) {
            this.playIdleAnimation();
        }

        if (["photo_idle"].indexOf(name) !== -1) {
            this.playPhotoIdleAnimation();
        }

        if (["jump_out"].indexOf(name) !== -1) {
            this._jumpOutFinished.dispatch();
        }
    }

    _onAnimationEvent(entry, event) {
    }

    //=============================
    //SLIDE IN/OUT
    //=============================
    slideInDorothy(tweens, destination, onStart, onComplete){
        return new P3.utils.TWEEN.Tween(this, tweens)
            .to({
                x: destination
            }, 750)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(onStart)
            .onComplete(onComplete);
    }

    slideOutDorothy(tweens, destination, onStart, onComplete){
        return new P3.utils.TWEEN.Tween(this, tweens)
            .to({
                x: destination
            }, 750)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(onStart)
            .onComplete(onComplete);
    }
}